import React from 'react';
const testimonials = [{
  name: 'Francesca M.',
  city: 'Milano',
  role: 'Istruttrice Pilates Matwork',
  initial: 'F',
  text: 'Ho recuperato i miei weekend. Le mie lezioni sono diventate più strutturate e le allieve me lo dicono ogni settimana. Investimento ripagato dopo la prima lezione.',
  bg: 'bg-primary/10',
  color: 'text-primary'
}, {
  name: 'Giulia R.',
  city: 'Roma',
  role: 'Studio Owner',
  initial: 'G',
  text: 'Avevo paura di non saper gestire le clienti con problemi alla colonna. Con i protocolli clinici ora ho una sicurezza totale. Le mie allieve si sentono finalmente capite.',
  bg: 'bg-secondary/15',
  color: 'text-secondary'
}, {
  name: 'Chiara B.',
  city: 'Firenze',
  role: 'Istruttrice Senior',
  initial: 'C',
  text: 'Insegno da 12 anni e questo Kit ha rivoluzionato la mia preparazione. Domenica pomeriggio non è più sinonimo di ansia. Le sequenze flow sono pura poesia.',
  bg: 'bg-accent-sage/15',
  color: 'text-accent-sage'
}, {
  name: 'Martina S.',
  city: 'Torino',
  role: 'Istruttrice Pilates Reformer',
  initial: 'M',
  text: 'Le schede per Gestanti e Terza Età mi hanno permesso di aprire due nuovi corsi nello studio. In due mesi ho ammortizzato 10 volte il costo del bundle.',
  bg: 'bg-primary/10',
  color: 'text-primary'
}, {
  name: 'Sara L.',
  city: 'Bologna',
  role: 'Istruttrice Freelance',
  initial: 'S',
  text: "Materiale di qualità professionale altissima. I disegni tecnici sono chiari, le progressioni logiche. Sembra fatto da una collega, non da un'azienda.",
  bg: 'bg-secondary/15',
  color: 'text-secondary'
}, {
  name: 'Valentina C.',
  city: 'Napoli',
  role: 'Istruttrice Matwork & Piccoli Attrezzi',
  initial: 'V',
  text: 'Le playlist e i certificati di risultato sono dettagli che fanno la differenza. Le mie allieve si sentono coccolate e questo si traduce in fidelizzazione.',
  bg: 'bg-accent-sage/15',
  color: 'text-accent-sage'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-20 px-4 relative overflow-hidden" data-id="element-220">
      <div className="absolute top-20 right-0 w-72 h-72 bg-primary/5 rounded-full blur-[80px] pointer-events-none" data-id="element-221"></div>
      <div className="absolute bottom-20 left-0 w-72 h-72 bg-secondary/5 rounded-full blur-[80px] pointer-events-none" data-id="element-222"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-223">
        <div className="text-center mb-12 sm:mb-16" data-id="element-224">
          <span className="inline-block bg-primary/10 text-primary text-xs sm:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full border border-primary/20 mb-5" data-id="element-225">
            💬 Testimonianze Verificate
          </span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4 tracking-tight" data-id="element-226">
            Cosa dicono le istruttrici italiane
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-227">
            <span className="text-secondary text-lg sm:text-xl" data-id="element-228">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec font-medium text-sm sm:text-base" data-id="element-229">
              4.9/5 da +800 recensioni
            </span>
          </div>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-230">
            Da Milano a Palermo, ecco la voce delle professioniste che hanno
            scelto il Pilates Elite Bundle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-231">
          {testimonials.map((t, i) => <article key={i} className="bg-white rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col shadow-[0_4px_20px_rgba(201,137,155,0.06)] hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(201,137,155,0.12)] transition-all duration-300 relative" data-id="element-232">
              <div className="text-secondary text-base mb-3" data-id="element-233">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-base leading-relaxed mb-6 flex-1 relative" data-id="element-234">
                <span className="text-primary/40 font-serif text-3xl absolute -top-2 -left-1 leading-none" data-id="element-235">
                  "
                </span>
                <span className="relative z-10 italic" data-id="element-236">{t.text}</span>
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-237">
                <div className={`w-11 h-11 rounded-full ${t.bg} ${t.color} flex items-center justify-center font-serif font-bold text-lg flex-shrink-0`} data-id="element-238">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-239">
                  <p className="text-text-main font-bold text-sm leading-tight truncate" data-id="element-240">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs flex items-center gap-1 mt-0.5" data-id="element-241">
                    <span className="text-primary" data-id="element-242">📍</span>
                    {t.city} · {t.role}
                  </p>
                </div>
                <span className="ml-auto text-check-green text-xs font-bold uppercase tracking-wider flex items-center gap-1 flex-shrink-0" title="Acquisto verificato" data-id="element-243">
                  <span className="w-1.5 h-1.5 rounded-full bg-check-green" data-id="element-244"></span>
                  <span className="hidden sm:inline" data-id="element-245">Verificata</span>
                </span>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm mt-10 font-medium" data-id="element-246">
          🇮🇹 Istruttrici da tutta Italia · Recensioni raccolte negli ultimi 6
          mesi
        </p>
      </div>
    </section>;
}